import { publishEvent, subscribeToEvent } from './EventServiceProvider';

export default class EventService {
  publish(...args) {
    return publishEvent(...args);
  }

  subscribe(...args) {
    return subscribeToEvent(...args);
  }

  static build() {
    return new EventService();
  }
}
